/* UserColorsModel */

import { types } from 'mobx-state-tree'




/* UserColorsCore Properties */
const coreProps = {
  primaryColor: types.optional(types.string, ""),
  secondaryColor: types.optional(types.string, ""),
  neuturalColor: types.optional(types.string, ""),
  lightBgColorColor: types.optional(types.string, ""),
  lightFgColor: types.optional(types.string, ""),
  darkBgColor: types.optional(types.string, ""),
  darkFgColor: types.optional(types.string, "")
}

/* Model Actions */
const coreActions = (self) => ({
  setPrimaryColor(color){
    self.primaryColor = color
  },
  setSecondaryColor(color){
    self.secondaryColor = color
  }
})

const UserColorsCoreModel = types
.model('UserColorsCoreModel')
.props(coreProps)
.actions(coreActions)







/* UserColorsModel Properties */
const colorProps = {
    core: types.optional(UserColorsCoreModel, {})
}

/* Model Actions */
const colorActions = (self) => ({})

const UserColorsModel = types
  .model('UserColorsModel')
  .props(colorProps)
  .actions(colorActions)

// export default UserColorsModel




/* UserStyleModel Properties */
const props = {
  colors: types.optional(UserColorsModel, {})
}

/* Model Actions */
const actions = (self) => ({})

const UserStyleModel = types
.model('UserStyleModel')
.props(props)
.actions(actions)

export default UserStyleModel





